import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';

import { finalize, tap } from 'rxjs/operators';
import { MessageService } from '../message.service';
import { Observable } from 'rxjs';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  // Static class variable to maintain the session id
  private SessionId;
  private SessionName = 'X-Session';

  constructor(
    private messenger: MessageService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
      if (this.SessionId) {
        request = request.clone({
          headers: request.headers.set(this.SessionName, this.SessionId)
        });
      }

      return next.handle(request)
        .pipe(
          tap(event => {
            if (event instanceof HttpResponse) {
              if (event.headers.get(this.SessionName)) {
                // If there is a session header, capture it so it can be set on future responses
                this.SessionId = event.headers.get(this.SessionName);
              }
            }
          })
        );
    }
}
